module.exports = __webpack_public_path__ + "static/media/book.b2e364f8.png";